<section class="background-color-nearwhite first">
    <div class="container">
        <h1 class="title" [innerHTML]="translationPrefix + '.headline' | translate"></h1>
        <ng-container *ngIf="courses$ | async as courses">
            <div *ngIf="courses.length > 0" class="large">
                <p [innerHTML]="translationPrefix + '.intro' | translate"></p>
            </div>
            <div *ngIf="courses && courses.length > 0" class="select-wrapper">
                <da-filtering
                    [categories]="categoriesForFilter$ | async"
                    [hasCourses]="showFilter$ | async"
                    (change)="onSelect($event)"
                    [filterName]="'common.filteringDropdownPleaseSelect' | translate"
                    [showTitleSearch]="false"
                    [isUserPage] = "isUserPage"
                ></da-filtering>
            </div>
            <div *ngIf="courses.length <= 0">
                <p class="intro large" [innerHTML]="translationPrefix + '.noCoursesAvailable' | translate"></p>
                <a
                    da-link
                    class="button secondary"
                    [routerLink]="coursesLink"
                    [innerHTML]="translationPrefix + '.noCoursesAvailableBtn' | translate"
                ></a>
            </div>
        </ng-container>
    </div>
</section>

<section class="background-color-nearwhite second">
    <ng-container *ngIf="coursesFiltered$ | async as coursesFiltered; else loader">
        <ng-container *ngIf="coursesFiltered && coursesFiltered.length >= 0">
            <div class="container" *ngIf="coursesFiltered && coursesFiltered.length > 0">
                <div class="courses">
                    <div *ngFor="let course of coursesFiltered">
                        <da-my-course-item
                            *ngIf="course"
                            [course]="course"
                            [status]="categories$ | async"
                            [testResults]="testResults$ | async"
                            [mycourses]="courses$ |async"
                        ></da-my-course-item>
                    </div>
                </div>
                <section [ngClass]="{ hidden: (showMoreInformation$ | async) === false }">
                    <div class="courses" [class.quick-view-wrapper]="active" [class.long-view-wrapper]="!active">
                        <div *ngFor="let course of coursesFilteredMore$ | async">
                            <da-my-course-item
                                *ngIf="course"
                                [course]="course"
                                [status]="categories$ | async"
                                [testResults]="testResults$ | async"
                                [mycourses]="courses$ | async"
                            ></da-my-course-item>
                        </div>
                    </div>
                </section>

                <section class="show-more" *ngIf="coursesFilteredMore$ | async as coursesFilteredMore">
                    <da-show-more
                        *ngIf="coursesFilteredMore.length > 0"
                        (toggle)="showMore($event)"
                        [labelMore]="'common.labelMore' | translate"
                        [labelLess]="'common.labelLess' | translate"
                        [backgroundColor]="'nearwhite'"
                    ></da-show-more>
                </section>
            </div>
            <ng-container *ngIf="courses$ | async as courses">
                <div class="container" *ngIf="courses && courses.length > 0 && coursesFiltered && coursesFiltered.length <= 0">
                    <span class="intro" [innerHTML]="translationPrefix + '.noCoursesAvailable' | translate"></span>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</section>

<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>
